import { useState } from 'react';
import { Send } from 'lucide-react';
import { RequestFilesModal, type RequestFilesTarget } from './RequestFilesModal';

export interface RequestFilesButtonProps {
  target: RequestFilesTarget;
  className?: string;
}

/**
 * "Request files", and the dialog it opens. One button for every record that
 * can be asked about — an attachment list, an event's files — so the dialog is
 * reached the same way everywhere. Producers only: callers render it for the
 * office alone.
 */
export function RequestFilesButton({
  target,
  className = 'flex items-center gap-1.5 px-3 py-2 min-h-11 sm:min-h-0 border border-gray-200 rounded-lg text-xs text-gray-600 hover:bg-gray-50 transition-colors',
}: RequestFilesButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className}
        data-testid="request-files-button"
      >
        <Send size={14} className="text-primary-600" />
        Request files
      </button>
      <RequestFilesModal open={open} onClose={() => setOpen(false)} {...target} />
    </>
  );
}
